import { Navigate } from "react-router-dom";
import { useRecoilValue } from "recoil";

import { Alert, Box, Stack } from "@mui/material";

import { ElementSideView } from "@/components/atoms/elements";
import { Translator } from "@/components/i18n";
import { TaskList } from "@/components/molecules/tasklist/TaskList";
import { Header } from "@/components/organisms/header";
import { SideBar } from "@/components/organisms/sidebar";
// import { ChatHistory } from "@/components/organisms/sidebar/ChatHistory";

import { userEnvState } from "@/state/user";
import { useAuth } from "@/client/api";
import { useConfig } from "@/client/useConfig";
import { sideViewState } from "@/client/state";
import { useLocation } from "react-router-dom";

import ResizableSplitView from "@/components/organisms/ResizableSplitView";

type Props = {
  children: JSX.Element;
  companyId?: string | number | undefined;
  setCompanyId?: (value: string) => void;
};

const Page = ({ children, companyId, setCompanyId }: Props) => {
  const { isAuthenticated } = useAuth();
  const { config } = useConfig();
  const userEnv = useRecoilValue(userEnvState);
  const sideViewElement = useRecoilValue(sideViewState);
  const location = useLocation();
  const isMainPage = !location.pathname.startsWith("/dashboard");

  // const isMobile = useMediaQuery("(max-width:66rem)");

  if (config?.userEnv) {
    for (const key of config.userEnv || []) {
      if (!userEnv[key]) return <Navigate to="/env" />;
    }
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        backgroundColor: (theme) =>
          isMainPage
            ? theme.palette.background.paper
            : theme.palette.background.default,
      }}
    >
      {!isAuthenticated ? (
        <Alert severity="error">
          <Translator path="pages.Page.notPartOfProject" />
        </Alert>
      ) : (
        <Stack
          direction="row"
          height="100%"
          width="100%"
          sx={{
            backgroundColor: "background.default",
          }}
        >
          <SideBar />
          {/* {!isMobile && <ChatHistory />} */}
          <Stack
            flexGrow={1}
            sx={{
              // border: "1px solid #ccc",
              borderBottomLeftRadius: "26px",
              borderTopLeftRadius: "26px",
              backgroundColor: "background.paper",
            }}
          >
            {isMainPage && (
              <Header companyId={companyId} setCompanyId={setCompanyId} />
            )}
            <ResizableSplitView>{children}</ResizableSplitView>
          </Stack>
          {sideViewElement ? null : <TaskList isMobile={false} />}
          <ElementSideView />
        </Stack>
      )}
    </Box>
  );
};

export default Page;
